// import React, { useEffect, useState, useRef } from "react";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";
// import courseService from "../../services/course.service";


// const GeneratedCertificate = ({ courseId, userId }) => {
//     const [certificat, setCertificat] = useState(null);
//     const certRef = useRef();

//     // Charger le certificat
//     useEffect(() => {
//         if (courseId && userId) {
//             courseService.getGeneratedCertificat(courseId, userId)
//                 .then(setCertificat)
//                 .catch((err) => console.error(err));
//         }
//     }, [courseId, userId]);
 


  


//     // Télécharger le certificat en PDF
//     const downloadPDF = async () => {
//         if (!certRef.current) return;
//         const canvas = await html2canvas(certRef.current, { scale: 2 });
//         const imgData = canvas.toDataURL("image/png");

//         const pdf = new jsPDF("landscape", "mm", "a4");
//         const imgWidth = 280;
//         const imgHeight = (canvas.height * imgWidth) / canvas.width;
//         pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
//         pdf.save("certificat.pdf");
//     };

//     if (!certificat) return <p>Chargement du certificat...</p>;

//     const settings = JSON.parse(certificat.templateSettings || "{}");

//     return (
//         <div style={{ textAlign: "center", marginTop: 20 }}>
//             <h2>🎉 Certificat généré pour {certificat.userName}</h2>
//             <p>Date de génération : {certificat.generatedDate}</p>

//             {/* Zone d'affichage du certificat */}
//             {/* <div
//                 ref={certRef}
//                 style={{
//                     backgroundColor: settings.backgroundColor || "#fff",
//                     color: settings.textColor || "#000",
//                     paddingTop: settings.paddingTop || 20,
//                     paddingBottom: settings.paddingBottom || 20,
//                     margin: "0 auto",
//                     width: "80%",
//                     border: "2px solid #ccc",
//                     boxShadow: "0 0 10px rgba(0,0,0,0.2)",
//                     borderRadius: 10,
//                 }}
//                 dangerouslySetInnerHTML={{ __html: certificat.htmlContent }}
//             /> */}
//         <div
//     ref={certRef}
//     style={{
//         backgroundColor: settings.backgroundColor || "#fff",
//         color: settings.textColor || "#000",
//         paddingTop: settings.paddingTop || 20,
//         paddingBottom: settings.paddingBottom || 20,
//         margin: "0 auto",
//         width: "80%",
//         border: "2px solid #ccc",
//         boxShadow: "0 0 10px rgba(0,0,0,0.2)",
//         borderRadius: 10,
//     }}
//     dangerouslySetInnerHTML={{
//         __html: certificat.htmlContent,   // ✅ On affiche directement l'HTML généré
//     }}
// />



//             {/* Bouton pour télécharger */}
//             <button
//                 onClick={downloadPDF}
//                 style={{
//                     marginTop: 20,
//                     padding: "10px 20px",
//                     backgroundColor: "#1890ff",
//                     color: "#fff",
//                     border: "none",
//                     borderRadius: 5,
//                     cursor: "pointer",
//                 }}
//             >
//                 ⬇️ Télécharger en PDF
//             </button>
//         </div>
//     );
// };

// export default GeneratedCertificate;
import React, { useEffect, useState, useRef } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import courseService from "../../services/course.service";

const GeneratedCertificate = ({ courseId, userId }) => {
    const [certificat, setCertificat] = useState(null);
    const certRef = useRef();

    // Charger le certificat
    useEffect(() => {
        if (courseId && userId) {
            courseService.getGeneratedCertificat(courseId, userId)
                .then((data) => {
                    if (data && data.htmlContent) {
                        // ✅ Nettoyage automatique du contenu avant affichage
                        let cleanedHtml = data.htmlContent
                            // Supprime balises autour de Nom Prénom
                            .replace(/<[^>]*>(?=Nom\s*Pr[ée]nom)|(?<=Nom\s*Pr[ée]nom)<[^>]*>/gi, "")
                            // Remplace toutes variantes Nom Prénom
                            .replace(/Nom\s*Pr[ée]nom/gi, "{{username}}")
                            .replace(/Pr[ée]nom\s*Nom/gi, "{{username}}")
                            // Supprime les doubles espaces
                            .replace(/\s{2,}/g, " ");

                        setCertificat({
                            ...data,
                            htmlContent: cleanedHtml,
                        });
                    } else {
                        setCertificat(data);
                    }
                })
                .catch((err) => console.error(err));
        }
    }, [courseId, userId]);

    // Télécharger le certificat en PDF
    const downloadPDF = async () => {
        if (!certRef.current) return;
        const canvas = await html2canvas(certRef.current, { scale: 2 });
        const imgData = canvas.toDataURL("image/png");

        const pdf = new jsPDF("landscape", "mm", "a4");
        const imgWidth = 280;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        pdf.addImage(imgData, "PNG", 10, 10, imgWidth, imgHeight);
        pdf.save("certificat.pdf");
    };

    if (!certificat) return <p>Chargement du certificat...</p>;

    const settings = JSON.parse(certificat.templateSettings || "{}");

    return (
        <div style={{ textAlign: "center", marginTop: 20 }}>
            <h2>🎉 Certificat généré pour {certificat.userName}</h2>
            <p>Date de génération : {certificat.generatedDate}</p>

            {/* Zone d'affichage du certificat */}
            <div
                ref={certRef}
                style={{
                    backgroundColor: settings.backgroundColor || "#fff",
                    color: settings.textColor || "#000",
                    paddingTop: settings.paddingTop || 20,
                    paddingBottom: settings.paddingBottom || 20,
                    margin: "0 auto",
                    width: "80%",
                    border: "2px solid #ccc",
                    boxShadow: "0 0 10px rgba(0,0,0,0.2)",
                    borderRadius: 10,
                }}
                dangerouslySetInnerHTML={{
                    __html: certificat.htmlContent, // ✅ HTML nettoyé avant affichage
                }}
            />

            {/* Bouton pour télécharger */}
            <button
                onClick={downloadPDF}
                style={{
                    marginTop: 20,
                    padding: "10px 20px",
                    backgroundColor: "#1890ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 5,
                    cursor: "pointer",
                }}
            >
                ⬇️ Télécharger en PDF
            </button>
        </div>
    );
};

export default GeneratedCertificate;
